<template>
  <div>
    <el-dialog :title="(claimNumber ? claimNumber : $t('common.create')) + ' ' + $t('claims.claim')"
               :visible.sync="showDialog"
               @open="loadClaim"
               @close="closeDialog"
               v-loading="loadingClaim"
               width="701px"
               class="claim-dialog"
               :close-on-click-modal="false"
               v-if="!showRma">
      <template slot="title">
              <span>
                  {{(claimNumber ? claimNumber : 'Create') + ' Claim'}}
                  <el-button @click="previewClaim(mutatedClaimId)">
                      {{$t('common.summary')}}
                  </el-button>
              </span>
      </template>
      <el-tabs v-model="activeStep"
               v-loading="loading">
        <el-tab-pane :label="$t('claims.claimAccountInformation')"
                     name="claimInfo"
                     v-loading="loading">
          <el-form ref="general"
                   :model="generalForm"
                   :rules="generalRules"
                   size="small"
                   label-width="200px"
                   label-position="left">
            <el-form-item :label="$t('common.serviceTicketNumber')"
                          prop="serviceTicketNumber">
  
              <service-ticket-selector v-model="generalForm.serviceTicketNumber" />
            </el-form-item>
            <el-form-item :label="$t('claims.90daysWarranty')"
                          prop="is90DaysWarranty">
              <el-switch v-model="generalForm.is90DaysWarranty"></el-switch>
            </el-form-item>
            <el-form-item :label="$t('claims.serviceWorkOrderNumber')"
                          prop="serviceWorkOrder">
              <el-input v-model="generalForm.serviceWorkOrder"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.invoiceNumber')"
                          prop="invoiceNumber">
              <el-input v-model="generalForm.invoiceNumber"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.serviceCoverage')"
                          prop="serviceCoverage">
              <service-coverage-selector v-model="generalForm.serviceCoverage" forExclude="8"></service-coverage-selector>
            </el-form-item>
            <el-form-item :label="$t('common.dateOfDispatch')"
                          prop="dateOfDispatch">
              <el-date-picker v-model="generalForm.dateOfDispatch"
                              type="date"></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('claims.dateWorkCompleted')"
                          prop="dateWorkCompleted">
              <el-date-picker v-model="generalForm.dateWorkCompleted"
                              type="date"></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('common.model')"
                          prop="productId">
              <product-selector v-model="generalForm.productId"></product-selector>
            </el-form-item>
            <el-form-item :label="$t('common.serialNumber')"
                          prop="serialNumber">
              <el-input v-model="generalForm.serialNumber"></el-input>
            </el-form-item>
            <el-form-item :label="$t('claims.workOrders')"
                          prop="workOrders">
              <el-upload name="workOrders"
                         drag
                         multiple
                         :file-list="generalForm.workOrders"
                         :auto-upload="false"
                         :limit="5"
                         action=""
                         :on-change="workOrderChanged"
                         :on-remove="workOrderRemoved"
                         :on-preview="handlePreview">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  {{$t('serviceTickets.dropFile')}}
                  <em>{{$t('serviceTickets.clicktoUpload')}}</em>
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('claims.siteInformation')"
                     name="siteInfo"
                     v-if="localClaimId"
                     v-loading="loading">
          <el-form ref="siteInfo"
                   :model="siteInfoForm"
                   :rules="siteInfoRules"
                   size="small"
                   label-width="200px"
                   label-position="left">
            <el-form-item :label="$t('claims.clientStore')"
                          prop="customerId">
              <customer-selector v-model="siteInfoForm.customerId"
                                 ref="customerIdSelector"></customer-selector>
            </el-form-item>
            <!--TODO Language-->
            <el-form-item label="Work Order Signed &amp; Approved By"
                          prop="orderSignedBy">
              <el-input v-model="siteInfoForm.orderSignedBy"></el-input>
            </el-form-item>
            <el-form-item :label="$t('common.subContractor')">
              <el-select v-model="siteInfoForm.subcontractorId" :placeholder="$t('claims.pleaseSelectSubContractor')" :loading="loading">
                <el-option v-for="item in subcontractors" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Sub-Agent" v-if="companyType == 2">
              <el-select v-model="siteInfoForm.subagentId" :placeholder="$t('claims.pleaseSelectSubAgent')" :loading="loading">
                <el-option v-for="item in childCompanies" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('claims.serviceTechnicianName')"
                          prop="technicianName">
              <el-input v-model="siteInfoForm.technicianName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('claims.serviceRequestedBy')"
                          prop="serviceRequestedBy">
              <el-input v-model="siteInfoForm.serviceRequestedBy"></el-input>
            </el-form-item>
            <el-form-item :label="$t('claims.reportSymptoms')"
                          prop="complaint">
              <el-input type="textarea"
                        :rows="3"
                        v-model="siteInfoForm.complaint"></el-input>
            </el-form-item>
            <el-button size="mini"
                       @click="showRepairCodeDialog">
              {{$t('claims.clickHereToAddRepairCodes')}}
            </el-button>
            <el-button size="mini"
                       @click="showMultiRepairCodeDialog">
              {{$t('claims.clickHereToAddMultipleRepairCodesPerformedWithSingleLaborTime')}}
            </el-button>
            <el-table :data="repairCodes"
                      class="tablewithshading"
                      size="mini">
              <el-table-column :label="$t('common.code')" width="80">
                <template slot-scope="scope">
                  <el-tooltip effect="dark"
                              :content="scope.row.code.name.split(' - ')[1]"
                              placement="top">
                    <el-tag type="info"
                            size="small"
                            :disable-transitions="true"
                            style="margin-right:5px;">{{scope.row.code.name.split(' - ')[0]}}</el-tag>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="regularTime"
                               :label="$t('claims.regTime')"
                               width="50"></el-table-column>
              <el-table-column prop="overTime"
                               :label="$t('common.overTime')" width="53"></el-table-column>
              <el-table-column prop="supplementaryRegularTime"
                               :label="$t('claims.suppRegTime')" width="53"></el-table-column>
              <el-table-column prop="supplementaryOverTime"
                               :label="$t('claims.suppOverTime')" width="53"></el-table-column>
              <el-table-column prop="supplementaryComment"
                               :label="$t('common.comment')"
                               align="center"
                               width="286"></el-table-column>
              <el-table-column :label="$t('common.operations')"
                               align="center"
                               width="85">
                <template slot-scope="scope">
                  <i class="el-icon-edit"
                     @click="editCode(scope.row)"></i>
                  <i class="el-icon-delete"
                     @click="deleteCode(scope.row.code.id)"></i>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
          <add-repair-code-dialog :visible.sync="repairCodeDialogVisible"
                                  :productId="generalForm.productId"
                                  :codeToEdit="repairCodeToEdit"
                                  :multiple="isMultiCodeAdd"
                                  @codes-selected="codesAdded"
                                  @dialogClosed="repairCodeDialogClosed"></add-repair-code-dialog>
        </el-tab-pane>
        <!--TODO Language-->
        <el-tab-pane label="Labor &amp; Travel"
                     name="laborTravel"
                     v-if="localClaimId"
                     v-loading="loading">
          <el-row :gutter="50">
            <el-col :span="24">
              <el-form ref="laborTravel"
                       :model="laborTravelForm"
                       :rules="laborTravelRules"
                       size="small"
                       label-width="300px"
                       label-position="left">
                <el-form-item :label="$t('claims.numberOfTrips')"
                              prop="numberOfTrips">
                  <el-input-number :debounce="0"
                                   :min="1"
                                   v-model="laborTravelForm.numberOfTrips"></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('claims.chooseExplanation')"
                              prop="tripsExplanationEnum"
                              v-if="laborTravelForm.numberOfTrips > 1">
                  <el-select v-model="laborTravelForm.tripsExplanationEnum"
                             class="full-width">
                    <el-option :value="1"
                               :label="$t('claims.customerRequestedWeReturn')"></el-option>
                    <el-option :value="2"
                               :label="$t('claims.didNotHaveThePartsOnHandInStock')"></el-option>
                    <el-option :value="3"
                               :label="$t('claims.technicalKnowledgeIssue')"></el-option>
                    <el-option :value="4"
                               :label="$t('claims.hardtRequestedWeReturn')"></el-option>
                    <el-option :value="5"
                               :label="$t('claims.ovenInUse')"></el-option>
                    <el-option :value="6"
                               :label="$t('claims.otherExplanation')"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('claims.enterExplanation')"
                              prop="tripsExplanation"
                              v-if="laborTravelForm.tripsExplanationEnum == 6 && laborTravelForm.numberOfTrips > 1">
                  <!--laborTravelForm.tripsExplanationEnum == 6 is value for other explanation-->
                  <el-input type="text" v-model="laborTravelForm.tripsExplanation" :maxLength="200"></el-input>
                </el-form-item>
                <el-form-item :label="$t('claims.regularTravelHours')"
                              prop="regularTravelHours">
                  <el-input type="number"
                            :min="0"
                            :max="maxRegularTravel"
                            v-model="laborTravelForm.regularTravelHours"
                            v-on:blur="recalculateRegularTravelHours"></el-input>
                </el-form-item>
                <el-form-item :label="$t('claims.overtimeTravelHours')"
                              prop="overtimeTravelHours">
                  <el-input :min="0"
                            :max="maxOvertimeTravel"
                            v-model="laborTravelForm.overtimeTravelHours"
                            v-on:blur="recalculateOvertimeTravelHours"></el-input>
                </el-form-item>
                <el-form-item :label="$t('claims.mileageMiles')"
                              prop="regularMileage">
                  <el-input :min="0"
                            :max="maxRegularMileage"
                            v-model="laborTravelForm.regularMileage"
                            v-on:blur="recalculateRegularMileage"></el-input>
                </el-form-item>
                <el-form-item :label="$t('claims.overtimeMileageMiles')"
                              prop="overtimeMileage">
                  <el-input :min="0"
                            :max="maxOvertimeMileage"
                            v-model="laborTravelForm.overtimeMileage"
                            v-on:blur="recalculateOvertimeMileage"></el-input>
                </el-form-item>
                <el-form-item :label="$t('claims.serviceFuelCharge')"
                              prop="serviceFuel">
                  <el-input :min="0"
                            :max="999"
                            v-model="laborTravelForm.serviceFuel"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
              <table>
                <tr>
                  <th></th>
                  <th>{{$t('common.hours')}}</th>
                  <th>{{$t('common.rate')}}</th>
                  <th>{{$t('common.total')}}</th>
                </tr>
                <tr>
                  <td>{{$t('common.labor')}}</td>
                  <td>{{laborHours || 0}}</td>
                  <td>{{rates.laborRate | money}}</td>
                  <td>{{laborHours * rates.laborRate | money}}</td>
                </tr>
                <tr>
                  <td>{{$t('claims.laborSupplementary')}}</td>
                  <td>{{laborSupplementaryHours || 0}}</td>
                  <td>{{rates.laborRate | money}}</td>
                  <td>{{laborSupplementaryHours * rates.laborRate | money}}</td>
                </tr>
                <tr>
                  <td>{{$t('claims.laborOvertime')}}</td>
                  <td>{{laborOvertimeHours || 0}}</td>
                  <td>{{rates.laborRateOverTime | money}}</td>
                  <td>{{laborOvertimeHours * rates.laborRateOverTime | money}}</td>
                </tr>
                <tr>
                  <td>{{$t('claims.laborOvertimeSupplementary')}}</td>
                  <td>{{laborOvertimeSupplementaryHours || 0}}</td>
                  <td>{{rates.laborRateOverTime | money}}</td>
                  <td>{{laborOvertimeSupplementaryHours * rates.laborRateOverTime | money}}</td>
                </tr>
                <tr>
                  <td>{{$t('claims.travel')}}</td>
                  <td>{{laborTravelForm.regularTravelHours}}</td>
                  <td>{{rates.travelRate | money}}</td>
                  <td>{{laborTravelForm.regularTravelHours * rates.travelRate | money}}</td>
                </tr>
                <tr>
                  <td>{{$t('claims.travelOvertime')}}</td>
                  <td>{{laborTravelForm.overtimeTravelHours}}</td>
                  <td>{{rates.travelRateOverTime | money}}</td>
                  <td>{{laborTravelForm.overtimeTravelHours * rates.travelRateOverTime | money}}</td>
                </tr>
                <tr>
                  <td>{{$t('common.mileage')}}</td>
                  <td>{{laborTravelForm.regularMileage}}</td>
                  <td>{{rates.mileageRate | money}}</td>
                  <td>{{laborTravelForm.regularMileage * rates.mileageRate | money}}</td>
                </tr>
                <tr>
                  <td>{{$t('claims.mileageOvertime')}}</td>
                  <td>{{laborTravelForm.overtimeMileage}}</td>
                  <td>{{rates.mileageRateOverTime | money}}</td>
                  <td>{{laborTravelForm.overtimeMileage * rates.mileageRateOverTime | money}}</td>
                </tr>
                <tr>
                  <!--TODO Language-->
                  <td>Service &amp; Fuel</td>
                  <td>{{laborTravelForm.serviceFuel}}</td>
                  <td></td>
                  <td>{{laborTravelForm.serviceFuel | money}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    {{ freightTaxTotal | money }}
                  </td>
                </tr>
              </table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="$t('common.parts')"
                     name="parts"
                     v-if="localClaimId"
                     v-loading="loading">
          <h3>Rma</h3>
          <div>
            <el-button :disabled="this.parts.length == 0" type="primary" @click="openRmaForm" v-if="showRmaButton">{{$t('claims.rmaCreateRMA')}}</el-button>
            <el-button :disabled="rmaForm.id != 0" type="primary" @click="sendRmaFormLink" v-if="isServiceCompany == false && showRmaButton">{{$t('claims.createRMALink')}}</el-button>
            <el-button @click="printRma()"
                       :loading="printing"
                       :disabled="rmaForm.id == 0">
              <i class="el-icon-printer"></i>
            </el-button>
          </div>
          <hr />
  
          <h3>
            Parts
            <el-button size="mini"
                       @click="showAddPart">{{$t('claims.clickHereToAddParts')}}</el-button>
          </h3>
          <el-table :data="parts"
                    size="mini"
                    class="tablewithshading">
            <el-table-column :label="$t('common.partNum')">
              <template slot-scope="scope">
                <el-tooltip effect="dark"
                            :content="scope.row.part.name"
                            placement="top">
                  <el-tag type="info"
                          size="small"
                          :disable-transitions="true"
                          style="margin-right:5px;">{{scope.row.part.partNo}}</el-tag>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="part.name"
                             :label="$t('common.name')"
                             width="250"></el-table-column>
            <el-table-column :label="$t('common.price')">
              <template slot-scope="scope">
                {{scope.row.part.price | money}}
              </template>
            </el-table-column>
            <el-table-column prop="part.extendedPrice"
                             :label="$t('common.extPrice')">
              <template slot-scope="scope">
                {{scope.row.part.extendedPrice * scope.row.quantity | money}}
              </template>
            </el-table-column>
            <el-table-column prop="quantity"
                             :label="$t('common.quantity')"></el-table-column>
            <el-table-column :label="$t('common.operations')"
                             align="center">
              <template slot-scope="scope">
                <i class="el-icon-delete"
                   @click="deletePart(scope.row.part.id)"></i>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <h3>
            {{$t('claims.miscParts')}}
            <el-button size="mini"
                       @click="showAddMiscPart">{{$t('claims.clickHereToAddMiscellaneousParts')}}</el-button>
          </h3>
          <el-table :data="miscParts"
                    size="mini"
                    style="width: 100%"
                    class="tablewithshading">
            <el-table-column prop="part.name"
                             :label="$t('claims.partName')"></el-table-column>
            <el-table-column :label="$t('common.price')">
              <template slot-scope="scope">
                {{scope.row.part.price | money}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.extendedPrice')">
              <template slot-scope="scope">
                {{(Number(scope.row.part.price) * Number(scope.row.quantity)) | money}}
              </template>
            </el-table-column>
            <el-table-column prop="quantity"
                             :label="$t('common.quantity')"></el-table-column>
            <el-table-column :label="$t('common.operations')"
                             align="center">
              <template slot-scope="scope">
                <i class="el-icon-delete"
                   @click="deleteMiscPart(scope.row.part.name)"></i>
              </template>
            </el-table-column>
          </el-table>
          <add-part-dialog :visible.sync="partDialogVisible"
                           :serviceCompanyId="siteInfoForm.serviceCompanyId"
                           :productId="generalForm.productId"
                           :misc="isMiscPartDialog"
                           :isNotWarrantyClaim="isNotWarrantyClaim"
                           @part-added="partAdded"
                           @dialogClosed="partDialogClosed"></add-part-dialog>
        </el-tab-pane>
        <el-tab-pane :label="$t('common.total')"
                     name="freightTax"
                     v-if="localClaimId"
                     v-loading="loading">
          <el-row>
            <table style="margin-bottom: 20px;"
                   class="freight-total">
              <tr>
                <td>
                  {{$t('claims.labourTravel')}}
                </td>
                <td>
                  {{ freightTaxTotal | money }}
                </td>
              </tr>
              <tr>
                <td>{{$t('common.parts')}}</td>
                <td>{{ partsTotal | money }}</td>
              </tr>
              <tr>
                <td>{{$t('claims.handling')}}</td>
                <td>{{ handling | money }}</td>
              </tr>
            </table>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form ref="freightTax"
                       :model="totalForm"
                       :rules="totalRules"
                       size="small"
                       label-width="200px"
                       label-position="left">
                <el-form-item :label="$t('common.freight')"
                              prop="freight">
                  <el-input-number :controls="false"
                                   v-model="totalForm.freight"
                                   class="full-width"></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('claims.hardtOriginalInvoice')"
                              prop="hardtInvoice"
                              class="full-width"
                              v-if="totalForm.freight >= 50">
                  <el-input v-model="totalForm.hardtInvoice"
                            class="full-width"></el-input>
                </el-form-item>
                <el-form-item :label="$t('claims.tax')"
                              prop="tax">
                  <el-input-number :controls="false"
                                   v-model="totalForm.tax"
                                   class="full-width"></el-input-number>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              &nbsp;
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
              <div>
                  <el-button v-if="isDcsCompany"
                             type="primary"
                             icon="el-icon-document"
                             @click="openDcsDialog">DCS Work Order</el-button>
                  <el-button :disabled="loading"
                             v-if="activeStep !== 'claimInfo' && activeStep !== 'comments'&& ($isUser || $isFullAdmin)"
                             @click="back">{{$t('common.back')}}</el-button>
                  <el-button :disabled="loading"
                             type="primary"
                             @click="next"
                             v-if="activeStep !== 'comments'&& ($isUser || $isFullAdmin)">{{nextButton}}</el-button>
                  <el-button :disabled="loading"
                             @click="closeDialog">{{$t('common.close')}}</el-button>
              </div>
              <div v-if="claimId">
                  <el-scrollbar style="margin: 10px;">
                      <ul class="comment-box">
                          <li v-for="comment in comments"
                              :key="comment.id">
                              <el-row v-if="comment.attachments && comment.attachments.length > 0">
                                  <el-col :span="12">
                                      <div v-for="attachment in comment.attachments"
                                           :key="attachment.id">
                                          <a @click="handleAttachmentPreview(attachment)"
                                             style="cursor: pointer;">
                                              <i class="el-icon-document" />
                                              {{attachment.fileName}}
                                          </a>
                                      </div>
                                  </el-col>
                                  <el-col :span="12">
                                      <p>
                                          {{comment.message}}
                                      </p>
                                      <small>On {{comment.at | date}} by {{comment.author}}</small>
                                  </el-col>
                              </el-row>
                              <div v-else>
                                  <p>
                                      {{comment.message}}
                                  </p>
                                  <small>On {{comment.at | date}} by {{comment.author}}</small>
                              </div>
                          </li>
                      </ul>
                  </el-scrollbar>
                  <el-form v-loading="loading"
                           ref="commentForm"
                           :model="commentForm"
                           :rules="commentRules"
                           size="small"
                           v-if="$isUser || $isFullAdmin">
                      <el-form-item prop="comment"
                                    :show-message="false">
                          <el-input type="textarea"
                                    size="small"
                                    :rows="4"
                                    v-model="commentForm.comment"
                                    :placeholder="$t('claims.newComment')">
                          </el-input>
                      </el-form-item>
                      <el-form-item prop="status"
                                    :show-message="false"
                                    v-if="!$isUser">
                          <el-select v-model="commentForm.status"
                                     :placeholder="$t('claims.newClaimStatus')">
                              <el-option :label="$t('common.new')"
                                         value="1"></el-option>
                              <el-option :label="$t('common.acceptAndProcess')"
                                         value="2"></el-option>
                              <el-option :label="$t('common.moreinfoRequired')"
                                         value="3"></el-option>
                              <el-option :label="$t('common.rejected')"
                                         value="4"></el-option>
                              <el-option :label="$t('common.paid')"
                                         value="6"></el-option>
                              <el-option :label="$t('common.pendingReturnPart')"
                                         value="7"></el-option>
                              <el-option :label="$t('common.pendingRepairCodeCorrections')"
                                         value="8"></el-option>
                              <el-option :label="$t('common.correctedRepairCodes')"
                                         value="9"></el-option>
                          </el-select>
                      </el-form-item>
                      <el-form-item :label="$t('claims.attachment')"
                                    prop="attachments">
                          <el-upload name="attachments"
                                     drag
                                     multiple
                                     :file-list="commentForm.attachments"
                                     :auto-upload="false"
                                     :limit="10"
                                     action=""
                                     :on-change="attachmentsChanged"
                                     :on-preview="handlePreview">
                              <i class="el-icon-upload"></i>
                              <div class="el-upload__text">
                                  {{$t('serviceTickets.dropFile')}}
                                  <em>{{$t('serviceTickets.clicktoUpload')}}</em>
                              </div>
                          </el-upload>
                      </el-form-item>
                  </el-form>
                  <el-button :disabled="loading"
                             type="primary"
                             v-if="$isUser || $isFullAdmin"
                             @click="postComment">{{$t('claims.postComment')}}</el-button>
              </div>
          </span>
      <el-dialog :visible.sync="showImagePreview"
                 width="60%"
                 append-to-body>
        <img style="width: 100%;"
             v-bind:src="fileUrlPreview"
             alt=""
             v-if="fileExtension!=='pdf'" />
        <embed v-bind:src="fileUrlPreview"
               style="width: 100%; height: 600px;"
               type='application/pdf'
               v-if="fileExtension==='pdf'">
        <el-button @click="showImagePreview = false">{{$t('common.close')}}</el-button>
      </el-dialog>
    </el-dialog>
    <el-dialog :title="$t('claims.rma')"
               :visible.sync="showRma"
               @close="closeRma"
               width="701px"
               class="claim-dialog"
               :close-on-click-modal="false"
               v-else-if="showRma">
      <div id="rmaForm" style="display: flex; flex-direction: column">
        <div style="display:flex; justify-content: space-between;">
          <span><strong>{{$t('common.rmaNum')}}</strong>{{ rmaForm.rmaNumber }}</span>
          <span><strong>{{$t('common.rmaDate')}}</strong> {{ rmaForm.rmaDate }}</span>
        </div>
        <hr style="width: 100%;" />
        <div style="display: flex; flex-direction: column;">
          <h3>Return To</h3>
          <div style="display: flex; flex-direction: column;">
            <span>{{$t('common.hardtEquipmentManufacturing')}}</span>
            <span>{{$t('common.fifthAvenue')}}</span>
            <span>{{$t('common.montrealQuebec')}}</span>
            <span>{{$t('common.canadaH8T2V3')}}</span>
            <p>
              <attn-selector :attns="rmaForm.attns" v-model="rmaForm.attn"></attn-selector>
            </p>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <label style="width: 35%;">{{$t('common.reasonForReturn')}}</label>
            <el-select v-model="rmaForm.reason" style="width: 100%;" :placeholder="$t('common.pleseSelectReasonForReturn')">
              <el-option :label="$t('common.returnRequestFromRDLabManager')" value="Return Request from R&D Lab Manager"></el-option>
              <el-option :label="$t('common.returnRequestFromProductManager')" value="Return Request from Product Manager"></el-option>
              <el-option :label="$t('common.returnRequestFromProjectLeader')" value="Return Request from Project Leader"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <hr style="width: 100%;" />
      <div style="display: flex; flex-direction: column;">
        <h3>{{$t('common.customerSiteInfo')}}</h3>
        <span for="rmaForm.selectedCustomer.name">{{ rmaForm.selectedCustomer.name }}</span>
        <span for="rmaForm.selectedCustomer.phone">{{ rmaForm.selectedCustomer.phone }}</span>
      </div>
      <hr style="width: 100%;" />
      <div style="display: flex; flex-direction: column;">
        <h3>{{$t('common.serviceCoInfo')}}</h3>
        <span>{{ rmaForm.serviceCompany.name }}</span>
        <span>{{ rmaForm.serviceCompany.code }}</span>
        <span>{{ rmaForm.serviceCompany.street }}</span>
        <span>{{ rmaForm.serviceCompany.city }}, {{ rmaForm.serviceCompany.zip }}</span>
        <span>{{ rmaForm.serviceCompany.phone }}</span>
        <span>{{ rmaForm.serviceCompany.contactPersonName }}</span>
      </div>
      <hr style="width: 100%;" />
      <div style="display: flex; flex-direction: column;">
        <h3>{{$t('common.equipmentInformation')}}</h3>
        <div style="display: flex; flex-direction: row; align-items: center; height: 30px; margin-bottom: 15px; justify-content: space-between;">
          <label style="width: 20%; font-weight: 600;">{{$t('common.modelColon')}}</label>
          <div style="width: 80%;">
            <product-selector disabled v-model="generalForm.productId"></product-selector>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center; height: 30px; margin-bottom: 15px; justify-content: space-between;">
          <label style="width: 20%; font-weight: 600;">{{$t('common.serialNumColon')}}</label>
          <div style="width: 80%;">
            <span>{{ generalForm.serialNumber }}</span>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center; height: 30px; margin-bottom: 15px; justify-content: space-between;">
          <label style="width: 20%; font-weight: 600;">{{$t('common.serviceCoverageColon')}}</label>
          <div style="width: 80%;">
            <service-coverage-selector disabled v-model="generalForm.serviceCoverage"></service-coverage-selector>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; align-items: center; height: 30px; margin-bottom: 15px; justify-content: space-between;">
          <label style="width: 20%; font-weight: 600;">{{$t('common.reportSymptomColon')}}</label>
          <div style="width: 80%;">
            <span>{{ siteInfoForm.complaint }}</span>
          </div>
        </div>
      </div>
      <hr style="width: 100%;" />
      <div style="display: flex; flex-direction: column;">
        <div style="display: flex;">
          <label style="width: 25%; font-weight: 600;">
            {{$t('common.returnAuthorizationNum')}}
          </label>
          <div style="width: 75%;">
            <span>{{ rmaForm.serviceTicket.authNumber }}</span>
          </div>
        </div>
        <div style="display: flex;">
          <label style="width: 25%; font-weight: 600;">{{$t('common.authNumDateAndTimeColon')}}</label>
          <div style="width: 75%;">
            <span>{{ rmaForm.serviceTicket.raisedOn }}</span>
          </div>
        </div>
        <div style="display: flex;">
          <label style="width: 20%; font-weight: 600;">TSR:</label>
          <span style="width: 80%;">{{ rmaForm.serviceTicket.tsr }}</span>
        </div>
      </div>
      <hr style="width: 100%;" />
      <div style="display: flex; flex-direction: column; margin-top: 20px;">
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <label style="width: 35%;">{{$t('common.hardtServiceTicketNum')}}</label>
          <div style="width: 65%;">
            <el-input v-model="rmaForm.serviceTicketNumber"></el-input>
          </div>
        </div>
        <div style="display: flex;">
          <label style="width: 35%;">{{$t('common.hardtClaimNum')}}</label>
          <div style="width: 65%;">
            <span>{{ rmaForm.claimNumber }}</span>
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 10px;">
          <label style="width: 35%;">{{$t('common.hardtInvoicePartPurchaseNum')}}</label>
          <div style="width: 65%;">
            <el-input v-model="rmaForm.invoiceNumber"></el-input>
          </div>
        </div>
      </div>
      <hr style="width: 100%;" />
      <div style="display: flex; flex-direction: column;">
        <h3>{{$t('common.shippingMethodColon')}}</h3>
        <span>{{ rmaForm.shippingMethod }}</span>
        <div style="display: flex; align-items: center; margin-top: 10px;">
          <label style="width: 35%;">{{$t('common.trackingNum')}}</label>
          <div style="width: 65%;">
            <el-input v-model="rmaForm.trackingNumber"></el-input>
          </div>
        </div>
        <div v-if="isTrackInfoLoaded" style="display: flex; flex-direction: column; margin: 10px 0;">
          <div style="display: flex; flex-direction: row; min-height: 40px;">
            <div style="width: 50%; display: flex; flex-direction: column;">
              <label style="font-weight: 600;">{{$t('common.serviceColon')}}</label>
              <span>{{ trackForm.service }}</span>
            </div>
            <div style="width: 50%; display: flex; flex-direction: column;">
              <label style="font-weight: 600;">{{$t('common.weightColon')}}</label>
              <span>{{ trackForm.weight }}</span>
            </div>
          </div>
          <div style="display: flex; flex-direction: row; min-height: 40px;">
            <div style="width: 50%; display: flex; flex-direction: column;">
              <label style="font-weight: 600;">{{$t('common.shippedOnColon')}}</label>
              <span>{{ trackForm.date }}</span>
            </div>
            <div style="width: 50%; display: flex; flex-direction: column;">
              <label style="font-weight: 600;">{{$t('common.referenceNumbersColon')}}</label>
              <span style="white-space: pre;">{{ trackForm.referenceNumbers }}</span>
            </div>
          </div>
        </div>
        <div style="width: 80px; display: flex; flex-direction: row; align-self: flex-end; margin: 10px 0;">
          <el-button id="trackBtn" :disabled="loading"
                     type="primary"
                     @click="getTrackInfo">{{$t('common.track')}}</el-button>
        </div>
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
          <label style="width: 35%;">{{$t('common.comment')}}</label>
          <div style="width: 65%;">
            <el-input v-model="rmaForm.comment"></el-input>
          </div>
        </div>
        <!--<img src="static/ups_tracking.jpg"
        @click="openTrackingWindow"
        style="cursor: pointer; margin-left: auto; margin-right: auto; display: block;">-->
      </div>
      <hr style="width: 100%;" />
      <div style="display: flex; flex-direction: column;">
        <el-table :data="parts"
                  size="mini"
                  class="tablewithshading">
          <el-table-column :label="$t('common.partNum')">
            <template slot-scope="scope">
              <el-tooltip effect="dark"
                          :content="scope.row.part.name"
                          placement="top">
                <el-tag type="info"
                        size="small"
                        :disable-transitions="true"
                        style="margin-right:5px;">{{scope.row.part.partNo}}</el-tag>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="part.name"
                           :label="$t('common.name')"
                           width="250"></el-table-column>
          <el-table-column :label="$t('common.coo')">
            <template slot-scope="scope">
              {{scope.row.part.countryOfOrigin}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.price')">
            <template slot-scope="scope">
              {{scope.row.part.price | money}}
            </template>
          </el-table-column>
          <el-table-column prop="part.extendedPrice"
                           :label="$t('common.extPrice')">
            <template slot-scope="scope">
              {{(Number.isInteger(scope.row.quantity) ? (scope.row.part.extendedPrice * scope.row.quantity) : scope.row.part.extendedPrice) | money}}
            </template>
          </el-table-column>
          <el-table-column prop="quantity"
                           :label="$t('common.quantity')"></el-table-column>
        </el-table>
      </div>
      <hr style="width: 100%;" />
      <div style="display: flex; justify-content: flex-end; width: auto;">
        <el-button :disabled="loading"
                   type="primary"
                   @click="saveRma">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showDcsDialog"
               width="1000px"
               :append-to-body="true"
               :destroy-on-close="true"
               :before-close="closeDcsDialog">
      <template slot="title">
      </template>

      <dcs-work-order-form ref="dcsWorkOrderForm"
                           v-model="dcsForm"
                           :logo-src="require('@/assets/logo.png')"
                           :general-info="generalForm"
                           :site-info="siteInfoForm"
                           :service-company-id="siteInfoForm.serviceCompanyId || currentCompany"/>

      <span slot="footer" class="dialog-footer">
                    <el-button type="primary"
                               :loading="generatingDcsPdf"
                               @click="attachDcsPdfToWorkOrders">Add to Work Orders</el-button>
                    <el-button @click="closeDcsDialog">Close</el-button>
                </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  CustomerSelector,
  ServiceTicketSelector,
  ProductSelector,
  ServiceCoverageSelector,
  AttnSelector
} from "@/app/shared/components";
import DcsWorkOrderForm from './DcsWorkOrderForm.vue';
import AddRepairCodeDialog from "./AddRepairCodeDialog";
import AddPartDialog from "./AddPartDialog";
import { EventBus } from "@/app/event-bus.js";
import api from "../api";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const createEmptyDcsForm = () => {
  const today = new Date().toISOString().slice(0, 10);
  return {
    workOrderNo: "",
    date: today,
    technicianNo: "",
    flags: { warranty: false, nonWarranty: false, callBack: false },
    equipment: { model1: "", model2: "", serial1: "", serial2: "", manufacturer: "" },
    site: { name: "", storeNo: "", street: "", city: "", zip: "", phone: "", contact: "" },
    request: { complaintNotes: "", fuelGas: false, fuelPropane: false },
    work: { description: "", recommendations: "" },
    partsRows: Array.from({ length: 3 }, () => ({ part1: "", partData: null, qty1: "", part2: "", qty2: "" })),
    workEntries: Array.from({ length: 5 }, () => ({
      date: "",
      travel1: "",
      mileage1: "",
      timeIn: "",
      laborHrs: "",
      timeOut: "",
      travel2: "",
      mileage2: "",
      total: ""
    })),
    sign: { customerName: "", customerTitle: "", date: today, signature: null }
  };
};

export default {
  name: "create-update-claim-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    claimId: {
      required: false
    }
  },
  components: {
    DcsWorkOrderForm,
    CustomerSelector,
    ProductSelector,
    ServiceCoverageSelector,
    ServiceTicketSelector,
    AddRepairCodeDialog,
    AddPartDialog,
    AttnSelector
  },
  data() {
    const that = this;
    return {
      showDcsDialog: false,
      generatingDcsPdf: false,
      dcsForm: createEmptyDcsForm(),
      trackForm: {},
      isTrackInfoLoaded: false,
      rmaForm: {
        rmaNumber: null,
        rmaDate: '',
        attns: [],
        attn: "",
        selectedCustomer: {},
        serviceCompany: {},
        serviceTicket: {
          raisedOn: '',
          authNumber: '',
          tsr: ''
        },
        serviceCompanyId: '',
        serviceTicketId: '',
        invoiceNumber: '',
        claimNumber: '',
        serviceTicketNumber: undefined,
        shippingMethod: '',
        countryOfOrigin: '',
        parts: [],
        claimId: '',
        id: '',
        claimStatus: ''
      },
      printing: false,
      localClaimId: null,
      claimNumber: undefined,
      claimStatus: -1,
      fileUrlPreview: null,
      fileExtension: null,
      showImagePreview: false,
      oldInvoiceNumber: "",
      generalForm: {
        serviceWorkOrder: "",
        invoiceNumber: "",
        serviceCoverage: undefined,
        dateOfDispatch: "",
        dateWorkCompleted: "",
        productId: undefined,
        serialNumber: "",
        is90DaysWarranty: false,
        workOrders: [],
        serviceTicketNumber: ""
      },
      generalRules: {
        serviceWorkOrder: [
          {
            message: this.$t('common.pleaseEnterServiceWorkOrderNumber'),
            required: true
          }
        ],
        invoiceNumber: [
          {
            message: this.$t('common.pleaseEnterInvoiceNumber'),
            required: true
          },
          {
            validator: (rule, value, callback) => {
              if (this.claimNumber && value === this.oldInvoiceNumber) {
                callback();
              } else {
                this.oldInvoiceNumber = value;
                api
                    .validateInvoiceNumber(value, this.localClaimId)
                    .then(response => {
                      if (response.data) {
                        callback();
                      } else {
                        callback(new Error(this.$t('common.invoiceNumberMustBeUnique')));
                      }
                    });
              }
            },
            trigger: "blur"
          }
        ],
        serviceCoverage: [
          {
            message: this.$t('shared.pleaseSelectServiceCoverage'),
            required: true,
            trigger: "change"
          }
        ],
        dateOfDispatch: [
          {
            type: "date",
            message: this.$t('common.pleaseEnterDateOfDispatch'),
            required: true,
            trigger: "change"
          },
          {
            validator: (rule, value, callback) => {
              if (value >= new Date()) {
                callback(new Error(this.$t('common.dateOfDispatchMustBeBeforeToday')));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        dateWorkCompleted: [
          {
            type: "date",
            message: this.$t('common.pleaseEnterDateWorkCompleted'),
            required: true,
            trigger: "change"
          },
          {
            validator: (rule, value, callback) => {
              if (value >= new Date()) {
                callback(new Error(this.$t('common.dateWorkCompletedMustBeBeforeToday')));
              } else {
                callback();
              }
            },
            trigger: "change"
          },
          {
            validator: (rule, value, callback) => {
              if (
                  value <
                  new Date(
                      that.generalForm.dateOfDispatch.getFullYear(),
                      that.generalForm.dateOfDispatch.getMonth(),
                      that.generalForm.dateOfDispatch.getDate()
                  )
              ) {
                callback(
                    new Error(
                        this.$t('common.dateWorkCompletedMustBeAfterOrEqualDateOfDispatch')
                    )
                );
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ],
        productId: [
          {
            message: this.$t('common.pleaseSelectModel'),
            required: true,
            trigger: "change"
          }
        ],
        serialNumber: [
          {
            message: this.$t('common.pleaseEnterSerialNumber'),
            required: true
          },
          {
            validator: (rule, value, callback) => {
              if (this.generalForm.productId === undefined) {
                callback(new Error(this.$t('common.pleaseSelectProductFirst')));
                return;
              }
              if (this.generalForm.productId === undefined) {
                callback(new Error(this.$t('common.pleaseSelectServiceCoverageFirst')));
                return;
              }
              api
                  .validateSerialNumber(
                      value,
                      this.generalForm.productId,
                      this.generalForm.serviceCoverage,
                      this.generalForm.is90DaysWarranty
                  )
                  .then(result => {
                    if (result.success) {
                      callback();
                    } else {
                      callback(new Error(result.error));
                    }
                  });
            },
            trigger: "change"
          }
        ],
        workOrders: [
          {
            type: "array",
            message: this.$t('common.workOrderIsRequired'),
            required: true,
            trigger: "change"
          }
        ],
        serviceTicketNumber: [
          {
            message: this.$t('common.pleaseEnterServiceTicketNumber'),
            required: true
          },
          {
            validator: (rule, value, callback) => {
              api.validateServiceTicketNumber(
                  value
              )
                  .then(result => {
                    if (result.data) {
                      callback();
                    } else {
                      callback(new Error(this.$t('common.serviceTicketNumberNotFound')));
                    }
                  })
            },
            trigger: "change"
          }
        ]
      },

      siteInfoForm: {
        customerId: undefined,
        serviceCompanyId: undefined,
        subagentId: undefined,
        orderSignedBy: "",
        technicianName: "",
        serviceRequestedBy: "",
        complaint: ""
      },
      siteInfoRules: {
        customerId: [
          {
            message: this.$t('common.pleaseEnterCustomerId'),
            required: true,
            trigger: "change"
          }
        ],
        orderSignedBy: [
          {
            message: this.$t('common.pleaseEnterOrderSignedBy'),
            required: true
          }
        ],
        technicianName: [
          {
            message: this.$t('common.pleaseEnterTechnicianName'),
            required: true
          }
        ],
        serviceRequestedBy: [
          {
            message: this.$t('common.pleaseEnterServiceRequestedBy'),
            required: true
          }
        ],
        complaint: [
          {
            message: this.$t('common.pleaseEnterSymptoms'),
            required: true
          }
        ]
      },
      laborTravelForm: {
        numberOfTrips: 1,
        regularTravelHours: 0,
        overtimeTravelHours: 0,
        regularMileage: 0,
        overtimeMileage: 0,
        serviceFuel: 0,
        tripsExplanationEnum: undefined,
        tripsExplanation: undefined
      },
      laborTravelRules: {
        numberOfTrips: [
          {
            type: "number",
            message: this.$t('common.pleaseEnterNumberOfTrips'),
            required: true
          }
        ],
        regularTravelHours: [
          {
            message: this.$t('common.pleaseEnterRegularTravelHours'),
            required: true
          },
          {
            validator: (rule, value, callback) => {
              if (!/^(\d*\.)?\d+$/.test(value)) {
                callback(new Error(this.$t('common.regularTravelHoursMustBeANumber')));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        overtimeTravelHours: [
          {
            message: this.$t('common.pleaseEnterOvertimeTravelHours'),
            required: true
          },
          {
            validator: (rule, value, callback) => {
              if (!/^(\d*\.)?\d+$/.test(value)) {
                callback(new Error(this.$t('common.overtimeTravelHoursMustBeANumber')));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        regularMileage: [
          {
            message: this.$t('common.pleaseEnterRegularMileage'),
            required: true
          },
          {
            validator: (rule, value, callback) => {
              if (!/^(\d*\.)?\d+$/.test(value)) {
                callback(new Error(this.$t('common.mileageMustBeANumber')));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        overtimeMileage: [
          {
            message: this.$t('common.pleaseEnterOvertimeMileage'),
            required: true
          },
          {
            validator: (rule, value, callback) => {
              if (!/^(\d*\.)?\d+$/.test(value)) {
                callback(
                    new Error(this.$t('common.overtimeMileageMustBeANumber'))
                );
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        serviceFuel: [
          {
            message: this.$t('common.pleaseEnterFuel'),
            required: true
          },
          {
            validator: (rule, value, callback) => {
              if (!/^(\d*\.)?\d+$/.test(value)) {
                callback(new Error(this.$t('common.serviceFuelChargeMustBeANumber')));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },

      totalForm: {
        freight: 0,
        hardtInvoice: undefined,
        tax: 0
      },
      totalRules: {
        hardtInvoice: [
          {
            validator: (rule, value, callback) => {
              if (this.totalForm.freight >= 50 && value === "") {
                callback(new Error(this.$t('common.invoiceIsRequired')));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        freight: [
          {
            validator: (rule, value, callback) => {
              if (!/^(\d*\.)?\d+$/.test(value)) {
                callback(new Error(this.$t('common.freightMustBeANumber')));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        tax: [
          {
            validator: (rule, value, callback) => {
              if (!/^(\d*\.)?\d+$/.test(value)) {
                callback(new Error(this.$t('common.taxMustBeANumber')));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },

      commentForm: {
        comment: "",
        status: null,
        attachments: []
      },
      commentRules: {
        comment: [
          {
            required: true,
            message: this.$t('common.pleaseEnterCommentText'),
            trigger: "blur"
          }
        ]
      },

      loading: false,
      loadingClaim: false,
      showDialog: this.visible,
      showRma: this.rmaVisible,
      isServiceCompany: this.rmaForServiceCompany,
      showRmaButton: this.rmaButtonVisible,
      repairCodeDialogVisible: false,
      partDialogVisible: false,
      isMiscPartDialog: false,
      isMultiCodeAdd: false,
      repairCodeToEdit: undefined,
      activeStep: "claimInfo",
      isNew: true,
      comments: [],
      parts: [],
      miscParts: [],
      repairCodes: [],
      isNotWarrantyClaim: false,
      subcontractors: {},
      subagents: {},
      companyType: "1"
    };
  },
  computed: {
    rates() {
      if (
          [2, 3, 4, 8].indexOf(parseInt(this.generalForm.serviceCoverage)) === -1
      ) {
        // if not CostcoNonWarranty and not CostcoMaintenance and not WalMartNonWarranty
        return window.currentCompany.rates.warranty;
      } else {
        return window.currentCompany.rates.nonWarranty;
      }
    },
    mutatedClaimId() {
      return this.localClaimId;
    },
    nextButton() {
      return this.activeStep === "freightTax"
          ? this.localClaimId
              ? this.$isAdmin
                  ? "Save"
                  : "Preview" // : "Submit"
              : "Preview"
          : "Next";
    },
    currentCompany() {
      return window.currentCompany.id;
    },
    isDcsCompany() {
        return (window.currentCompany.shipToName || '').trim() === 'DCS';
    },
    maxRegularTravel: function () {
      return (
          window.currentCompany.rates.maxTravelPerTrip *
          this.laborTravelForm.numberOfTrips -
          this.laborTravelForm.overtimeTravelHours
      );
    },
    maxOvertimeTravel: function () {
      return (
          window.currentCompany.rates.maxTravelPerTrip *
          this.laborTravelForm.numberOfTrips -
          this.laborTravelForm.regularTravelHours
      );
    },
    maxRegularMileage: function () {
      return (
          window.currentCompany.rates.maxMileagePerTrip *
          this.laborTravelForm.numberOfTrips -
          this.laborTravelForm.overtimeMileage
      );
    },
    maxOvertimeMileage: function () {
      return (
          window.currentCompany.rates.maxMileagePerTrip *
          this.laborTravelForm.numberOfTrips -
          this.laborTravelForm.regularMileage
      );
    },
    laborHours: function () {
      return this.repairCodes
          .map(c => c.regularTime)
          .reduce((p, c) => p + c, 0);
    },
    laborSupplementaryHours: function () {
      return this.repairCodes
          .map(c => c.supplementaryRegularTime)
          .reduce((p, c) => p + c, 0);
    },
    laborOvertimeHours: function () {
      return this.repairCodes.map(c => c.overTime).reduce((p, c) => p + c, 0);
    },
    laborOvertimeSupplementaryHours: function () {
      return this.repairCodes
          .map(c => c.supplementaryOverTime)
          .reduce((p, c) => p + c, 0);
    },
    canEdit: function () {
      return (
          (this.mutatedClaimId || this.isNew) &&
          [-1, 0, 1, 3, 5, 8].indexOf(this.claimStatus) !== -1
      );
    },
    partsTotal: function () {
      let total = 0;
      this.parts.forEach(part => {
        total = total + part.part.extendedPrice * part.quantity;
      });
      this.miscParts.forEach(part => {
        total = total + part.part.price * part.quantity;
      });
      return total;
    },
    handling: function () {
      let handling = 0;
      var coverage = parseInt(this.generalForm.serviceCoverage);
      var isWarrantyClaim = coverage !== 2 && coverage !== 3 && coverage !== 4 && coverage !== 8;
      if (isWarrantyClaim && this.totalForm.freight <= 0) {
        handling = this.partsTotal * 0.15;
      }
      return handling;
    },
    freightTaxTotal: function () {
      return (
          Number(this.laborHours) * Number(this.rates.laborRate) +
          Number(this.laborSupplementaryHours) * Number(this.rates.laborRate) +
          Number(this.laborOvertimeHours) * Number(this.rates.laborRateOverTime) +
          Number(this.laborOvertimeSupplementaryHours) *
          Number(this.rates.laborRateOverTime) +
          Number(this.laborTravelForm.regularTravelHours) *
          Number(this.rates.travelRate) +
          Number(this.laborTravelForm.overtimeTravelHours) *
          Number(this.rates.travelRateOverTime) +
          Number(this.laborTravelForm.regularMileage) *
          Number(this.rates.mileageRate) +
          Number(this.laborTravelForm.overtimeMileage) *
          Number(this.rates.mileageRateOverTime) +
          Number(this.laborTravelForm.serviceFuel)
      );
    }
  },
  watch: {
    visible: function (val) {
      this.showDialog = val;
    },
    generalForm: {
      deep: true,
      handler() {
        this.syncClaimFormsToDcs();
      }
    },
    siteInfoForm: {
      deep: true,
      handler() {
        this.syncClaimFormsToDcs();
      }
    },
    laborTravelForm: {
      deep: true,
      handler() {
        this.syncClaimFormsToDcs();
      }
    },
    repairCodes: {
      deep: true,
      handler() {
        this.syncClaimFormsToDcs();
      }
    },
    dcsForm: {
      deep: true,
      handler() {
        this.syncDcsToClaimForms();
      }
    },
    rmaVisible: function (val) {
      this.showRma = val;
    },
    rmaForServiceCompany: function (val) {
      this.isServiceCompany = val;
    },
    rmaButtonVisible: function (val) {
      this.showRmaButton = val;
    },
  },
  mounted() {
    this.syncClaimFormsToDcs();
    api.getRmaNumber().then(response => {
      this.rmaForm.rmaNumber = response.data.data;
    });

    EventBus.$on("confirmed", () => {
      this.$notify({
        title: this.$t('common.success'),
        message: this.$t('common.claimSuccesfullySaved'),
        type: "success"
      });
      this.closeDialog();
      EventBus.$emit("claim-created");
    });
  },
  beforeDestroy() {
    EventBus.$off("confirmed");
  },
  methods: {
    highlightFormFields(refName, props) {
      this.$nextTick(() => {
        const formRef = this.$refs[refName];
        if (!formRef || !formRef.validateField || !Array.isArray(props)) {
          return;
        }

        props.forEach(prop => formRef.validateField(prop));
      });
    },
    getDcsOpeningBlocker() {
      const missingGeneralProps = [];
      if (this.isBlank(this.generalForm.serviceTicketNumber)) {
        missingGeneralProps.push("serviceTicketNumber");
      }
      if (this.isBlank(this.generalForm.serviceWorkOrder)) {
        missingGeneralProps.push("serviceWorkOrder");
      }
      if (this.isBlank(this.generalForm.invoiceNumber)) {
        missingGeneralProps.push("invoiceNumber");
      }
      if (this.isBlank(this.generalForm.serviceCoverage)) {
        missingGeneralProps.push("serviceCoverage");
      }
      if (!this.generalForm.dateOfDispatch) {
        missingGeneralProps.push("dateOfDispatch");
      }
      if (!this.generalForm.dateWorkCompleted) {
        missingGeneralProps.push("dateWorkCompleted");
      }
      if (this.isBlank(this.generalForm.productId)) {
        missingGeneralProps.push("productId");
      }
      if (this.isBlank(this.generalForm.serialNumber)) {
        missingGeneralProps.push("serialNumber");
      }

      if (missingGeneralProps.length > 0) {
        return {
          step: "claimInfo",
          refName: "general",
          props: missingGeneralProps,
          message: "Complete the required Claim Information fields before opening the DCS work order."
        };
      }

      return null;
    },
    openDcsDialog() {
      const blocker = this.getDcsOpeningBlocker();
      if (blocker) {
        this.activeStep = blocker.step;
        this.highlightFormFields(blocker.refName, blocker.props);
        this.$notify({
          title: "Warning",
          message: blocker.message,
          type: "warning"
        });
        return;
      }

      this.syncClaimFormsToDcs();
      this.showDcsDialog = true;
    },
    getDcsWorkOrderFileName() {
      const workOrderNo = (this.dcsForm && this.dcsForm.workOrderNo) || this.generalForm.serviceWorkOrder || "draft";
      const safeWorkOrderNo = `${workOrderNo}`.replace(/[\\/:*?"<>|]+/g, "-");
      return `DCS-WorkOrder-${safeWorkOrderNo}.pdf`;
    },
    removeExistingDcsWorkOrderAttachment(fileName) {
      this.generalForm.workOrders = this.generalForm.workOrders.filter(attachment => {
        const attachmentName = attachment && (attachment.name || attachment.fileName || attachment.Name);
        return attachmentName !== fileName;
      });
    },
    buildPdfFile(blob, fileName) {
      return new File([blob], fileName, {
        type: "application/pdf",
        lastModified: Date.now()
      });
    },
    async attachDcsPdfToWorkOrders() {
      if (this.generatingDcsPdf) {
        return;
      }

      const dcsWorkOrderForm = this.$refs["dcsWorkOrderForm"];
      if (!dcsWorkOrderForm || !dcsWorkOrderForm.validate) {
        return;
      }

      const isValid = await dcsWorkOrderForm.validate();
      if (!isValid) {
        return;
      }

      this.generatingDcsPdf = true;
      try {
        await this.$nextTick();
        const element = dcsWorkOrderForm.$el;
        if (!element) {
          return;
        }

        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#ffffff"
        });

        const pdf = new jsPDF("p", "mm", "letter");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imageData = canvas.toDataURL("image/png");
        const imageWidth = pageWidth;
        const imageHeight = (canvas.height * imageWidth) / canvas.width;
        let heightLeft = imageHeight;
        let position = 0;

        pdf.addImage(imageData, "PNG", 0, position, imageWidth, imageHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
          position = heightLeft - imageHeight;
          pdf.addPage();
          pdf.addImage(imageData, "PNG", 0, position, imageWidth, imageHeight);
          heightLeft -= pageHeight;
        }

        const fileName = this.getDcsWorkOrderFileName();
        const pdfBlob = pdf.output("blob");
        const pdfFile = this.buildPdfFile(pdfBlob, fileName);

        this.removeExistingDcsWorkOrderAttachment(fileName);
        this.generalForm.workOrders.push(pdfFile);

        if (this.$refs["general"]) {
          this.$refs["general"].validateField("workOrders");
        }

        this.$notify({
          title: this.$t('common.success'),
          message: "The DCS work order PDF was added to Work Orders.",
          type: "success"
        });
      } finally {
        this.generatingDcsPdf = false;
      }
    },
    isBlank(value) {
      return value === "" || value === null || typeof value === "undefined";
    },
    isZeroLike(value) {
      return this.isBlank(value) || Number(value) === 0;
    },
    createEmptyDcsPartRow() {
      return { part1: "", partData: null, qty1: "", part2: "", qty2: "" };
    },
    ensureDcsForm() {
      if (!this.dcsForm) {
        this.dcsForm = createEmptyDcsForm();
      }
      if (!Array.isArray(this.dcsForm.partsRows)) {
        this.$set(this.dcsForm, "partsRows", []);
      }
      return this.dcsForm;
    },
    hasDcsWorkEntryValue(entry) {
      return ["date", "travel1", "mileage1", "timeIn", "laborHrs", "timeOut", "travel2", "mileage2"]
          .some(key => !this.isBlank(entry[key]));
    },
    formatDateForDcs(value) {
      if (!value) {
        return "";
      }
      if (value instanceof Date) {
        const month = `${value.getMonth() + 1}`.padStart(2, "0");
        const day = `${value.getDate()}`.padStart(2, "0");
        return `${value.getFullYear()}-${month}-${day}`;
      }
      return `${value}`.slice(0, 10);
    },
    isEmptyDcsPartRow(row) {
      return !row || (this.isBlank(row.part1) && this.isBlank(row.qty1));
    },
    ensureDcsPartRowCount(count) {
      const dcs = this.ensureDcsForm();
      while (dcs.partsRows.length < count) {
        dcs.partsRows.push(this.createEmptyDcsPartRow());
      }
    },
    findDcsRowByPartId(partId) {
      const dcs = this.ensureDcsForm();
      return dcs.partsRows.findIndex(row => Number(row.part1) === Number(partId));
    },
    findFirstEmptyDcsRow() {
      const dcs = this.ensureDcsForm();
      return dcs.partsRows.findIndex(row => this.isEmptyDcsPartRow(row));
    },
    syncClaimFormsToDcs() {
      const dcs = this.ensureDcsForm();

      if (this.isBlank(dcs.site.storeNo) && !this.isBlank(this.siteInfoForm.customerId)) {
        dcs.site.storeNo = this.siteInfoForm.customerId;
      }
      if (!this.isBlank(this.siteInfoForm.complaint) && dcs.request.complaintNotes !== this.siteInfoForm.complaint) {
        dcs.request.complaintNotes = this.siteInfoForm.complaint;
      }
      if (this.isBlank(dcs.technicianNo) && !this.isBlank(this.siteInfoForm.technicianName)) {
        dcs.technicianNo = this.siteInfoForm.technicianName;
      }
      if (!this.isBlank(this.siteInfoForm.orderSignedBy) && dcs.sign.customerName !== this.siteInfoForm.orderSignedBy) {
        dcs.sign.customerName = this.siteInfoForm.orderSignedBy;
      }

      if (Array.isArray(dcs.workEntries) && dcs.workEntries.length > 0) {
        const totalLaborHours =
            Number(this.laborHours || 0) +
            Number(this.laborSupplementaryHours || 0) +
            Number(this.laborOvertimeHours || 0) +
            Number(this.laborOvertimeSupplementaryHours || 0);

        const firstEntry = dcs.workEntries[0];
        if (this.isBlank(firstEntry.date) && this.generalForm.dateWorkCompleted) {
          firstEntry.date = this.formatDateForDcs(this.generalForm.dateWorkCompleted);
        }
        if (this.isBlank(firstEntry.travel1) && Number(this.laborTravelForm.regularTravelHours) > 0) {
          firstEntry.travel1 = `${this.laborTravelForm.regularTravelHours}`;
        }
        if (this.isBlank(firstEntry.travel2) && Number(this.laborTravelForm.overtimeTravelHours) > 0) {
          firstEntry.travel2 = `${this.laborTravelForm.overtimeTravelHours}`;
        }
        if (this.isBlank(firstEntry.mileage1) && Number(this.laborTravelForm.regularMileage) > 0) {
          firstEntry.mileage1 = `${this.laborTravelForm.regularMileage}`;
        }
        if (this.isBlank(firstEntry.mileage2) && Number(this.laborTravelForm.overtimeMileage) > 0) {
          firstEntry.mileage2 = `${this.laborTravelForm.overtimeMileage}`;
        }
        if (this.isBlank(firstEntry.laborHrs) && totalLaborHours > 0) {
          firstEntry.laborHrs = `${totalLaborHours}`;
        }
      }

      const claimParts = Array.isArray(this.parts) ? this.parts : [];
      this.ensureDcsPartRowCount(Math.max(3, claimParts.length));
      claimParts.forEach(partRow => {
        if (!partRow || !partRow.part || !partRow.part.id) {
          return;
        }

        let rowIndex = this.findDcsRowByPartId(partRow.part.id);
        if (rowIndex === -1) {
          rowIndex = this.findFirstEmptyDcsRow();
        }
        if (rowIndex === -1) {
          rowIndex = dcs.partsRows.length;
          dcs.partsRows.push(this.createEmptyDcsPartRow());
        }

        const targetRow = dcs.partsRows[rowIndex];
        if (this.isBlank(targetRow.part1)) {
          targetRow.part1 = partRow.part.id;
        }
        if (!targetRow.partData) {
          targetRow.partData = Object.assign({}, partRow.part);
        }
        if (this.isBlank(targetRow.qty1) && !this.isBlank(partRow.quantity)) {
          targetRow.qty1 = `${partRow.quantity}`;
        }
      });
    },
    syncDcsToClaimForms() {
      const dcs = this.ensureDcsForm();

      if (this.isBlank(this.siteInfoForm.customerId) && !this.isBlank(dcs.site.storeNo)) {
        this.siteInfoForm.customerId = dcs.site.storeNo;
      }
      if (!this.isBlank(dcs.request.complaintNotes) && this.siteInfoForm.complaint !== dcs.request.complaintNotes) {
        this.siteInfoForm.complaint = dcs.request.complaintNotes;
      }
      if (this.isBlank(this.siteInfoForm.technicianName) && !this.isBlank(dcs.technicianNo)) {
        this.siteInfoForm.technicianName = dcs.technicianNo;
      }
      if (!this.isBlank(dcs.sign.customerName) && this.siteInfoForm.orderSignedBy !== dcs.sign.customerName) {
        this.siteInfoForm.orderSignedBy = dcs.sign.customerName;
      }

      const workEntries = Array.isArray(dcs.workEntries) ? dcs.workEntries : [];
      const usedEntries = workEntries.filter(entry => this.hasDcsWorkEntryValue(entry));
      const regularTravelTotal = usedEntries.reduce((sum, entry) => sum + Number(entry.travel1 || 0), 0);
      const overtimeTravelTotal = usedEntries.reduce((sum, entry) => sum + Number(entry.travel2 || 0), 0);
      const regularMileageTotal = usedEntries.reduce((sum, entry) => sum + Number(entry.mileage1 || 0), 0);
      const overtimeMileageTotal = usedEntries.reduce((sum, entry) => sum + Number(entry.mileage2 || 0), 0);

      if (this.laborTravelForm.numberOfTrips === 1 && usedEntries.length > 1) {
        this.laborTravelForm.numberOfTrips = usedEntries.length;
      }
      if (this.isZeroLike(this.laborTravelForm.regularTravelHours) && regularTravelTotal > 0) {
        this.laborTravelForm.regularTravelHours = regularTravelTotal;
      }
      if (this.isZeroLike(this.laborTravelForm.overtimeTravelHours) && overtimeTravelTotal > 0) {
        this.laborTravelForm.overtimeTravelHours = overtimeTravelTotal;
      }
      if (this.isZeroLike(this.laborTravelForm.regularMileage) && regularMileageTotal > 0) {
        this.laborTravelForm.regularMileage = regularMileageTotal;
      }
      if (this.isZeroLike(this.laborTravelForm.overtimeMileage) && overtimeMileageTotal > 0) {
        this.laborTravelForm.overtimeMileage = overtimeMileageTotal;
      }

      const dcsParts = (Array.isArray(dcs.partsRows) ? dcs.partsRows : [])
          .filter(row => !this.isBlank(row.part1) && row.partData)
          .map(row => ({
            part: Object.assign({}, row.partData),
            quantity: Number(row.qty1 || 1)
          }));

      dcsParts.forEach(partRow => {
        const existingIndex = this.parts.findIndex(existing => existing.part && existing.part.id === partRow.part.id);
        if (existingIndex === -1) {
          this.parts.push(partRow);
          return;
        }

        const existingPart = this.parts[existingIndex];
        if (Number(existingPart.quantity) === Number(partRow.quantity) &&
            JSON.stringify(existingPart.part) === JSON.stringify(partRow.part)) {
          return;
        }

        this.$set(this.parts, existingIndex, {
          part: Object.assign({}, existingPart.part, partRow.part),
          quantity: partRow.quantity
        });
      });
    },
    getTrackInfo() {
      if (!this.rmaForm.trackingNumber) {
        return;
      }
      this.loading = true;
      api.
      getTrackingInfo(this.rmaForm.trackingNumber)
          .then(response => {
            this.trackForm = response.data;
            this.isTrackInfoLoaded = true;
            this.loading = false;
          })
          .catch(err => {
            console.log(err);
          });
    },
    printRma() {
      this.printing = true;
      api.printRma(this.rmaForm.id).then(
          response => {
            this.printing = false;
            var oHiddFrame = document.createElement("iframe");
            oHiddFrame.style.visibility = "hidden";
            oHiddFrame.style.position = "fixed";
            oHiddFrame.style.right = "0";
            oHiddFrame.style.bottom = "0";
            oHiddFrame.src = "javascript:void(0)";
            document.body.appendChild(oHiddFrame);
            var dstDoc =
                oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
            dstDoc.write(response.data);

            dstDoc.close();
            var isFirefox = typeof InstallTrigger !== "undefined";
            if (isFirefox) {
              oHiddFrame.contentWindow.print();
              document.body.removeChild(oHiddFrame);
            } else {
              setTimeout(function () {
                oHiddFrame.contentWindow.print();
                document.body.removeChild(oHiddFrame);
              }, 500);
            }
          },
          () => (this.printing = false)
      );
    },
    openTrackingWindow() {
      var url = "http://www.ups.com/WebTracking/track?loc=en_US&WT.svl=PNRO_L1";
      window.open(url);
    },
    saveRma() {
      this.loading = true;
      api
          .saveRma(this.rmaForm)
          .then(response => {
            this.loading = false;
            this.showRma = false;
            this.rmaForm.id = response.data.id;
          })
          .catch(err => {
            console.log(err);
          });
    },
    sendRmaFormLink() {
      this.loading = true;
      api.sendRmaFormLink(this.rmaForm.claimId).then(response => {
        this.loading = false;
      });
    },
    loadClaim() {
      this.dcsForm = createEmptyDcsForm();
      this.localClaimId = this.claimId;
      if (this.localClaimId) {
        this.isNew = false;
        this.loading = true;
        this.loadingClaim = true;
        api.getClaim(this.localClaimId).then(response => {
          var that = this;
          this.claimNumber = response.data.claimNumber;
          this.claimStatus = response.data.claimStatus;
          this.generalForm = response.data.generalForm;
          this.generalForm.serviceCoverage = this.generalForm.serviceCoverage.toString();
          this.generalForm.dateOfDispatch = new Date(
              this.generalForm.dateOfDispatch
          );
          this.generalForm.dateWorkCompleted = new Date(
              this.generalForm.dateWorkCompleted
          );
          this.siteInfoForm = response.data.siteInfoForm;

          this.subcontractors = response.data.siteInfoForm.subcontractors;
          this.rmaForm.attns = response.data.rmaForm.attns;
          this.rmaForm.attn = response.data.rmaForm.attnId > 0 ? response.data.rmaForm.attns[response.data.rmaForm.attnId - 1].id : "";
          this.$refs["customerIdSelector"].searchCustomersById(
              response.data.siteInfoForm.customerId,
              function () {
                var customers = that.$refs["customerIdSelector"].getCustomers();
                that.rmaForm.selectedCustomer = customers[0];
              }
          );

          this.laborTravelForm = response.data.laborTravelForm;
          this.totalForm = response.data.totalForm;
          this.repairCodes = response.data.repairCodes;
          this.parts = response.data.parts;

          this.miscParts = response.data.miscParts;
          this.comments = response.data.comments;
          this.oldInvoiceNumber = response.data.generalForm.invoiceNumber;
          this.loading = false;
          this.loadingClaim = false;

          this.rmaForm.serviceCompany = response.data.rmaForm.serviceCompany;
          this.rmaForm.serviceTicket = {
            raisedOn: response.data.rmaForm.serviceTicket.raisedOn,
            // ? new Date(response.data.rmaForm.serviceTicket.raisedOn).toLocaleString("en-Ca") : new Date(),
            authNumber: response.data.rmaForm.serviceTicket.authNumber,
            tsr: response.data.rmaForm.serviceTicket.tsr
          };
          this.rmaForm.shippingMethod = response.data.rmaForm.shippingMethod;
          this.rmaForm.countryOfOrigin = response.data.rmaForm.countryOfOrigin;

          this.rmaForm.parts = response.data.parts.slice();
          var totalPrice = 0,
              totalExtendedPrice = 0;
          response.data.parts.map(function (e) { totalPrice += e.part.price; totalExtendedPrice += e.part.extendedPrice; });
          this.rmaForm.parts.push({ part: { partNo: 'Total', name: 'N/A', price: totalPrice, extendedPrice: totalExtendedPrice }, quantity: 'N/A' });

          this.rmaForm.serviceCompanyId = response.data.rmaForm.serviceCompanyId;
          this.rmaForm.serviceTicketId = response.data.rmaForm.serviceTicketId;
          this.rmaForm.claimId = response.data.rmaForm.claimId;

          this.rmaForm.claimNumber = response.data.rmaForm.claimNumber;
          this.rmaForm.invoiceNumber = response.data.rmaForm.invoiceNumber;
          this.rmaForm.serviceTicketNumber = response.data.rmaForm.serviceTicketNumber;
          this.rmaForm.id = response.data.rmaForm.id;
          this.showRmaButton = response.data.rmaForm.claimStatus == 7;
          this.rmaForm.claimStatus = response.data.rmaForm.claimStatus;
          this.isServiceCompany = response.data.rmaForm.isServiceCompany;
          this.rmaForm.rmaDate = response.data.rmaForm.rmaDate;

          self.isNotWarrantyClaim =
              response.data.generalForm.serviceCoverage == 2 ||
              response.data.generalForm.serviceCoverage == 3 ||
              response.data.generalForm.serviceCoverage == 4 ||
              response.data.generalForm.serviceCoverage == 8;

          this.syncClaimFormsToDcs();
        });
      }
    },
    workOrderChanged(file, fileList) {
      this.generalForm.workOrders.push(file.raw);
    },
    workOrderRemoved(file, fileList) {
      if (file.id) {
        var index = this.generalForm.workOrders.findIndex(
            attachment => attachment.id === file.id
        );
        this.generalForm.workOrders.splice(index, 1);
      } else {
        var index = this.generalForm.workOrders.findIndex(
            attachment => attachment.uid == file.uid
        );
        this.generalForm.workOrders.splice(index, 1);
      }
    },
    attachmentsChanged(file, fileList) {
      this.commentForm.attachments.push(file.raw);
    },
    back() {
      var self = this;
      if (this.activeStep === "freightTax") {
        this.activeStep = "parts";
        return;
      } else if (this.activeStep === "parts") {
        if (!this.canEdit && !this.$isAdmin) {
          this.activeStep = "laborTravel";
          return;
        }
        api
            .saveParts(this.mutatedClaimId, this.parts, this.miscParts)
            .then(response => {
              this.activeStep = "laborTravel";
            });
      } else if (this.activeStep === "laborTravel") {
        if (!this.canEdit && !this.$isAdmin) {
          this.activeStep = "siteInfo";
          return;
        }
        this.$refs["laborTravel"].validate(valid => {
          if (valid) {
            api
                .saveLaborTravel(this.mutatedClaimId, this.laborTravelForm)
                .then(response => {
                  this.activeStep = "siteInfo";
                });
          }
        });
      } else if (this.activeStep === "siteInfo") {
        if (!this.canEdit && !this.$isAdmin) {
          this.activeStep = "claimInfo";
          return;
        }
        this.$refs["siteInfo"].validate(valid => {
          if (valid) {
            api
                .saveSiteInfo(
                    this.mutatedClaimId,
                    this.siteInfoForm,
                    this.repairCodes
                )
                .then(response => {
                  self.siteInfoForm.serviceCompanyId =
                      response.data.serviceCompanyId;
                  this.activeStep = "claimInfo";
                });
          }
        });
      }
    },
    next() {
      var self = this;
      if (this.activeStep === "claimInfo") {
        if (!this.canEdit && !this.$isAdmin) {
          this.activeStep = "siteInfo";
          return;
        }

        this.$refs["general"].validate(valid => {
          if (valid) {
            api
                .saveGeneral(this.mutatedClaimId, this.generalForm)
                .then(response => {
                  if (response.data === false) {
                    this.$notify({
                      title: "Error",
                      message: this.$t('common.invoiceNumberMustBeUnique'),
                      type: "error"
                    });
                  }
                  else {
                    if (!this.$isAdmin && !this.localClaimId) {
                      this.localClaimId = response.data.claim.id;
                    }
                    this.claimNumber = response.data.claim.claimNumber;
                    this.subcontractors = response.data.subcontractors;
                    this.childCompanies = response.data.childCompanies;
                    this.companyType = response.data.companyType;
                    this.activeStep = "siteInfo";
                    self.isNotWarrantyClaim =
                        response.data.claim.coverage == 2 ||
                        response.data.claim.coverage == 3 ||
                        response.data.claim.coverage == 4;
                  }
                });
          }
        });
      } else if (this.activeStep === "siteInfo") {
        if (!this.canEdit && !this.$isAdmin) {
          this.activeStep = "laborTravel";
          return;
        }
        this.$refs["siteInfo"].validate(valid => {
          if (valid) {
            api
                .saveSiteInfo(
                    this.mutatedClaimId,
                    this.siteInfoForm,
                    this.repairCodes
                )
                .then(response => {
                  self.siteInfoForm.serviceCompanyId =
                      response.data.serviceCompanyId;
                  this.activeStep = "laborTravel";
                });
          }
        });
      } else if (this.activeStep === "laborTravel") {
        if (!this.canEdit && !this.$isAdmin) {
          this.activeStep = "parts";
          return;
        }
        this.$refs["laborTravel"].validate(valid => {
          if (valid) {
            api
                .saveLaborTravel(this.mutatedClaimId, this.laborTravelForm)
                .then(response => {
                  this.activeStep = "parts";
                });
          }
        });
      } else if (this.activeStep === "parts") {
        if (!this.canEdit && !this.$isAdmin) {
          this.activeStep = "freightTax";
          return;
        }
        api
            .saveParts(this.mutatedClaimId, this.parts, this.miscParts)
            .then(response => {
              this.activeStep = "freightTax";
            });
      } else if (this.activeStep === "freightTax") {
        if (!this.canEdit && !this.$isAdmin) {
          this.closeDialog();
          return;
        }
        this.$refs["freightTax"].validate(valid => {
          if (valid) {
            api
                .saveTotal(this.mutatedClaimId, this.totalForm, this.claimId)
                .then(response => {
                  if (typeof claimId == "undefined" || claimId == null) {
                    EventBus.$emit("showClaimConfirm", this.mutatedClaimId);
                  } else {
                    this.$emit("showClaimConfirm", this.mutatedClaimId);
                  }
                  // if (this.claimId && this.claimStatus == 0) {
                  // } else {
                  //   this.$notify({
                  //     title: this.$t('common.success'),
                  //     message: "Claim successfully saved.",
                  //     type: "success"
                  //   });
                  //   this.$emit("showClaimPreview", this.mutatedClaimId);
                  //   this.closeDialog();
                  // }
                });
          }
        });
      }
    },
    postComment() {
      this.$refs["commentForm"].validate(valid => {
        if (valid) {
          this.loading = true;
          api
              .submitComment(this.mutatedClaimId, this.commentForm)
              .then(response => {
                this.loading = false;
                this.$refs["commentForm"].resetFields();
                this.comments.push(response.data);
              })
              .catch(err => {
                console.log(err);
              });
        }
      });
    },
    openRmaForm() {
      this.showRma = true;
    },
    showRepairCodeDialog() {
      this.repairCodeDialogVisible = true;
    },
    showMultiRepairCodeDialog() {
      this.isMultiCodeAdd = true;
      this.repairCodeDialogVisible = true;
    },
    showAddPart() {
      this.partDialogVisible = true;
    },
    showAddMiscPart() {
      this.partDialogVisible = true;
      this.isMiscPartDialog = true;
    },
    repairCodeDialogClosed() {
      this.repairCodeToEdit = undefined;
      this.isMultiCodeAdd = false;
      this.repairCodeDialogVisible = false;
    },
    partDialogClosed() {
      this.isMiscPartDialog = false;
      this.partDialogVisible = false;
    },
    partAdded(payload) {
      if (
          this.isMiscPartDialog &&
          !this.miscParts.find(
              p => p.part.name.toLowerCase() === payload.part.name.toLowerCase()
          )
      ) {
        this.miscParts.push(payload);
      } else if (
          !this.isMiscPartDialog &&
          !this.parts.find(p => p.part.id === payload.part.id)
      ) {
        this.parts.push(payload);
      }
    },
    codesAdded(payload) {
      var presentIds = this.repairCodes.map(c => c.code.id);
      var newCodes = payload.codesToAdd;
      for (var i = 0; i < newCodes.length; i++) {
        var code = newCodes[i];
        var existingCode = newCodes.find(
            c => presentIds.indexOf(c.code.id) === 0
        );
        if (payload.codeToEdit) {
          this.repairCodes = this.repairCodes.filter(function (e, i) { return e.code.id != payload.codeToEdit.code.id; });
        }
        if (!existingCode) {
          this.repairCodes.push(code);
        } else {
          var index = this.repairCodes.findIndex(
              c => c.code.id === existingCode.code.id
          );
          this.$set(this.repairCodes, index, code);
        }
      }
    },
    deletePart(id) {
      this.parts = this.parts.filter(p => p.part.id !== id);
    },
    deleteMiscPart(name) {
      this.miscParts = this.miscParts.filter(p => p.part.name !== name);
    },
    deleteCode(id) {
      this.repairCodes = this.repairCodes.filter(c => c.code.id !== id);
    },
    editCode(code) {
      this.repairCodeToEdit = code;
      this.showRepairCodeDialog();
    },
    closeRma() {
      this.showRma = false;
    },
    closeDcsDialog(done) {
      const finalize = () => {
        this.showDcsDialog = false;
        if (typeof done === "function") {
          done();
        }
      };

      const dcsWorkOrderForm = this.$refs["dcsWorkOrderForm"];
      if (!dcsWorkOrderForm || !dcsWorkOrderForm.validate) {
        finalize();
        return;
      }

      dcsWorkOrderForm.validate().then(valid => {
        if (valid) {
          finalize();
          return;
        }

        this.$notify({
          title: "Error",
          message: "Please correct the highlighted DCS work order fields before closing.",
          type: "warning"
        });
      });
    },
    closeDialog() {
      this.isNew = true;
      this.claimNumber = undefined;
      this.parts = [];
      this.miscParts = [];
      this.repairCodes = [];
      this.comments = [];
      if (this.$refs["general"]) {
        this.$refs["general"].resetFields();
      }
      if (this.$refs["siteInfo"]) {
        this.$refs["siteInfo"].resetFields();
      }
      if (this.$refs["laborTravel"]) {
        this.$refs["laborTravel"].resetFields();
      }
      if (this.$refs["total"]) {
        this.$refs["total"].resetFields();
      }
      if (this.$refs["commentForm"]) {
        this.$refs["commentForm"].resetFields();
      }
      if (this.$refs["freightTax"]) {
        this.$refs["freightTax"].resetFields();
      }
      this.activeStep = "claimInfo";
      this.showDialog = false;
      this.showRma = false;
      this.showDcsDialog = false;
      this.dcsForm = createEmptyDcsForm();
      this.loading = false;
      this.$emit("dialogClosed");
    },
    previewClaim(id) {
      this.$emit("previewClaim", id);
      this.closeDialog();
    },
    handlePreview(file) {
      var split = file.name.split(".");
      this.fileExtension = split[split.length - 1];
      if (
          this.fileExtension !== "jpg" &&
          this.fileExtension !== "pdf" &&
          this.fileExtension !== "jpeg" &&
          this.fileExtension !== "png"
      ) {
        // window.open(file.url);
        api.download(file.url);
        return;
      }
      this.fileUrlPreview = file.url;
      this.showImagePreview = true;
    },
    handleAttachmentPreview(file) {
      this.fileExtension = file.mimeType.replace(".", "");
      if (
          this.fileExtension !== "jpg" &&
          this.fileExtension !== "pdf" &&
          this.fileExtension !== "jpeg" &&
          this.fileExtension !== "png"
      ) {
        // window.open(file.url);
        api.download(file.url);
        return;
      }
      this.fileUrlPreview = file.url;
      this.showImagePreview = true;
    },
    recalculateRegularTravelHours() {
      if (this.laborTravelForm.regularTravelHours > this.maxRegularTravel) {
        this.laborTravelForm.regularTravelHours = this.maxRegularTravel;
      }
    },
    recalculateOvertimeTravelHours() {
      if (this.laborTravelForm.overtimeTravelHours > this.maxOvertimeTravel) {
        this.laborTravelForm.overtimeTravelHours = this.maxOvertimeTravel;
      }
    },
    recalculateRegularMileage() {
      if (this.laborTravelForm.regularMileage > this.maxRegularMileage) {
        this.laborTravelForm.regularMileage = this.maxRegularMileage;
      }
    },
    recalculateOvertimeMileage() {
      if (this.laborTravelForm.overtimeMileage > this.maxOvertimeMileage) {
        this.laborTravelForm.overtimeMileage = this.maxOvertimeMileage;
      }
    }
  }
};
</script>

<style scoped>
.full-width,
.code {
  width: 100%;
}

.claim-dialog > .el-dialog__body {
  padding: 0 15px;
}

.comment-box {
  list-style: none;
  padding: 0;
  margin-top: 0;
  max-height: 400px;
}

.comment-box > li {
  margin-bottom: 10px;
}

.comment-box > p {
  margin-bottom: 0;
  margin-top: 0;
}

table {
  border-collapse: collapse;
}

table,
th,
td {
  border: 1px solid black;
}

th,
td {
  padding: 6px 25px;
}

.freight-total > tr > td {
  border-left: none;
  border-right: none;
}

.freight-total {
  border-left: none;
  border-right: none;
}
</style>



// WEBPACK FOOTER //
// ClientApp/app/claims/components/CreateUpdateClaimDialog.vue